import { fromJS, List } from 'immutable';
import { createAction, handleActions } from 'redux-actions';

export const initialState = fromJS({
  isLoading: false,
  isSectionsContentLoading: false,
  isArticleLoading: false,
  localeLoaded: null,
  sections: [],
  sectionsContent: {},
});

// const
export const GET_HOME_SECTIONS = 'home/GET_HOME_SECTIONS';
export const GET_HOME_ARTICLE = 'home/GET_HOME_ARTICLE';
export const PUT_HOME_START_FETCH = 'home/PUT_HOME_START_FETCH';
export const PUT_HOME_FINISH_FETCH = 'home/PUT_HOME_FINISH_FETCH';
export const PUT_HOME_SECTIONS = 'home/PUT_HOME_SECTIONS';
export const PUT_HOME_SECTION_CONTENT = 'home/PUT_HOME_SECTION_CONTENT';
export const PUT_HOME_SECTION_CONTENTS_LOADED =
  'home/PUT_HOME_SECTION_CONTENTS_LOADED';
export const PUT_HOME_ARTICLE = 'home/PUT_HOME_ARTICLE';
export const PUT_HOME_ARTICLE_START_FETCH = 'home/PUT_HOME_ARTICLE_START_FETCH';
export const PUT_HOME_ARTICLE_FINISH_FETCH =
  'home/PUT_HOME_ARTICLE_FINISH_FETCH';

// action creators
export const getHomeSections = createAction(GET_HOME_SECTIONS, (data) => data);
export const getHomeArticle = createAction(
  GET_HOME_ARTICLE,
  ({ sectionCode, articleCode }) => ({ sectionCode, articleCode }),
);
export const putHomeStartFetch = createAction(PUT_HOME_START_FETCH);
export const putHomeFinishFetch = createAction(PUT_HOME_FINISH_FETCH);
export const putHomeSections = createAction(PUT_HOME_SECTIONS);
export const putHomeSectionContent = createAction(PUT_HOME_SECTION_CONTENT);
export const putHomeSectionContentsLoaded = createAction(
  PUT_HOME_SECTION_CONTENTS_LOADED,
);
export const putHomeArticleStartFetch = createAction(
  PUT_HOME_ARTICLE_START_FETCH,
);
export const putHomeArticleFinishFetch = createAction(
  PUT_HOME_ARTICLE_FINISH_FETCH,
);
export const putHomeArticle = createAction(
  PUT_HOME_ARTICLE,
  ({ sectionCode, article }) => ({ sectionCode, article }),
);

// reducer
const homeReducer = handleActions(
  {
    [`${PUT_HOME_START_FETCH}`]: (state) =>
      state.set('isLoading', true).set('isSectionsContentLoading', true),

    [`${PUT_HOME_FINISH_FETCH}`]: (state) =>
      state.set('isLoading', false).set('isSectionsContentLoading', false),

    [`${PUT_HOME_ARTICLE_START_FETCH}`]: (state) =>
      state.set('isArticleLoading', true),

    [`${PUT_HOME_ARTICLE_FINISH_FETCH}`]: (state) =>
      state.set('isArticleLoading', false),

    [`${PUT_HOME_SECTIONS}`]: (
      state,
      { payload: { currentLocale, response } },
    ) =>
      state
        .set('localeLoaded', currentLocale)
        .set('sections', response.get('data'))
        .set('isLoading', false),

    [`${PUT_HOME_SECTION_CONTENT}`]: (state, { payload: { code, response } }) =>
      state.setIn(['sectionsContent', code], response.get('data')),

    [`${PUT_HOME_SECTION_CONTENTS_LOADED}`]: (state) =>
      state.set('isSectionsContentLoading', false),

    // Merges a single article into sectionsContent[sectionCode]. If the
    // section list already exists and contains an article with the same code,
    // the existing entry is replaced (keeping ordering stable); otherwise the
    // article is appended. If the section list doesn't exist yet, a new List
    // is created. This lets cold deep-links populate the cache without
    // overwriting data from an earlier full-sections fetch.
    [`${PUT_HOME_ARTICLE}`]: (state, { payload: { sectionCode, article } }) =>
      state.updateIn(['sectionsContent', sectionCode], (existing) => {
        const list = existing || List();
        const articleCode = article.get('code');
        const index = list.findIndex((a) => a.get('code') === articleCode);
        return index >= 0 ? list.set(index, article) : list.push(article);
      }),
  },
  initialState,
);

export default homeReducer;
